var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _c(
        "v-list-item",
        [
          _c(
            "v-list-item-content",
            [
              _c("v-list-item-title", [
                _vm._v("Modello: "),
                _c("strong", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rigaspedizione.modelloDecodificato.codiceParte
                      ) +
                      " "
                  ),
                ]),
                _vm._v(" - "),
                _c("strong", [_vm._v(_vm._s(_vm.rigaspedizione.codiceLAK))]),
                _vm._v(" - N. Ordine: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.rigaspedizione.ordineNumero) +
                      "/" +
                      _vm._s(_vm.rigaspedizione.ordineLinea)
                  ),
                ]),
                _vm._v(" - del: "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.formatDate(_vm.rigaspedizione.dataOrdine))),
                ]),
                _vm._v(" - scadenza: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.formatDate(_vm.rigaspedizione.dataScadenza))
                  ),
                ]),
              ]),
              _c("v-list-item-title", [
                _vm._v("Lavorazione: "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.rigaspedizione.idLavorazione)),
                ]),
              ]),
              _c("v-list-item-title", [
                _vm._v("Cod. Consegna: "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.rigaspedizione.codiceConsegna)),
                ]),
                _vm._v(" - Lotto: "),
                _c("strong", [_vm._v(_vm._s(_vm.rigaspedizione.lotto))]),
                _vm._v(" - "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.rigaspedizione.campionario
                        ? "CAMPIONARIO"
                        : "PRODUZIONE"
                    ) + " "
                  ),
                  _vm.rigaspedizione.firstCost == "S"
                    ? _c("span", [_vm._v(" USA")])
                    : _vm._e(),
                ]),
              ]),
              _c("v-list-item-subtitle", [
                _vm._v("Stagione: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.rigaspedizione.stagioneDecodificata.descrizione)
                  ),
                ]),
                _vm._v(" - Modello: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.rigaspedizione.modelloDecodificato.descrizione)
                  ),
                ]),
                _vm._v(" Colore: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.rigaspedizione.coloreDecodificato.descrizione)
                  ),
                ]),
              ]),
              _c("v-list-item-subtitle", [
                _vm._v("Fase: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.rigaspedizione.faseDecodificata.descrizione)
                  ),
                ]),
                _vm.rigaspedizione.lineaVenditaDecodificata
                  ? _c("span", [
                      _vm._v(" - Linea: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.rigaspedizione.lineaVenditaDecodificata
                              .descrizione
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _c(
            "v-list-item-action",
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", ripple: "" },
                  on: {
                    click: function ($event) {
                      _vm.deleteRigaDialog = true
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "pa-1",
                      attrs: { size: "25", color: "grey lighten-1" },
                    },
                    [_vm._v("mdi-delete")]
                  ),
                ],
                1
              ),
              _c(
                "v-dialog",
                {
                  attrs: { "hide-overlay": "", width: "800" },
                  model: {
                    value: _vm.deleteRigaDialog,
                    callback: function ($$v) {
                      _vm.deleteRigaDialog = $$v
                    },
                    expression: "deleteRigaDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "headline d-flex justify-space-between",
                        },
                        [
                          _vm._v(" Elimina riga "),
                          _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.deleteRigaDialog = false
                                },
                              },
                            },
                            [_vm._v("mdi-close")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c("v-row", { staticClass: "ma-5" }, [
                            _c("h2", [
                              _vm._v(
                                " Vuoi eliminare la riga associata alla lavorazione " +
                                  _vm._s(_vm.rigaspedizione.idLavorazione) +
                                  "?"
                              ),
                            ]),
                          ]),
                          _c(
                            "v-row",
                            { staticClass: "flex justify-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "success" },
                                  on: { click: _vm.deleteRiga },
                                },
                                [_vm._v("Sì")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.deleteRigaDialog = false
                                    },
                                  },
                                },
                                [_vm._v("No")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-list-item",
        [
          _c(
            "v-list-item-content",
            [
              _c(
                "v-expansion-panels",
                {
                  attrs: { variant: "popout" },
                  model: {
                    value: _vm.panel,
                    callback: function ($$v) {
                      _vm.panel = $$v
                    },
                    expression: "panel",
                  },
                },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        { staticStyle: { "background-color": "gainsboro" } },
                        [_vm._v(" Seriali EPC ")]
                      ),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c("v-row", { staticStyle: { margin: "12px" } }, [
                            _vm._v(" " + _vm._s(_vm.serialiEpc) + " "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-list-item",
        [
          _c(
            "v-list-item-content",
            [
              _c("v-list-item-title", [_vm._v("TAGLIE")]),
              _c(
                "v-data-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.items,
                    "hide-default-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "tr",
                            { staticClass: "rigaProgresso" },
                            [
                              _vm._l(item.values, function (value, index) {
                                return _c(
                                  "td",
                                  {
                                    key: "prog_" + value.value + "_" + index,
                                    staticStyle: { "text-align": "center" },
                                  },
                                  [
                                    value.value > 0
                                      ? _c(
                                          "span",
                                          {
                                            style: {
                                              color: value.color,
                                              "font-weight": value.fontWeight,
                                            },
                                          },
                                          [_vm._v(_vm._s(value.value))]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              _c(
                                "td",
                                [
                                  item.ddt
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            href: `/ddt/${item.ddt}`,
                                            target: "_blank",
                                          },
                                        },
                                        [_c("v-icon", [_vm._v("assignment")])],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "no-data" },
                    [
                      _c("v-alert", { attrs: { value: true, type: "info" } }, [
                        _vm._v(" Nessun valore presente. "),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }